<template>
    <app-layout>
        <div class="py-12 flex">
            <div class="max-w-7xl flex flex-grow flex-wrap mx-auto sm:px-6 lg:px-8">
                <incident :incident="$attrs.incident" :show-timeline="true" class="mx-auto"></incident>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Incident from "@/Components/Incident";

export default {
    components: {
        Incident,
        AppLayout,
    },
};
</script>
